import { LinearProgress } from "@material-ui/core";
import React from "react";
import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";

type Props = { progress: number };

const useStyles = makeThemedStyles("ProgressModal.inProgress", (theme) => ({
  percentageValue: {
    fontSize: "6.86em",
    color: "rgba(17, 94, 103, 1)",
  },
  progressBar: {
    height: "28px",
    borderRadius: "30px",
    border: "1px solid #0e9cf022",
    display: "flex",
    alignItems: "center",
    padding: "0 7.74px",
  },
  progressLine: {
    width: "500px",
    background: "#0e9cf057",
    height: "16px",
    borderRadius: "30px",
  },
  primaryBar: {
    background: "linear-gradient(91.14deg, #0e9cf0 0.97%, #0e9cf0 99.03%)",
    borderRadius: "30px",
  },
}));

const ProcessInProgress = (props: Props) => {
  const classes = useStyles();
  const { progress } = props;
  return (
    <>
      <div className={classes.percentageValue}>{progress.toFixed(0)}%</div>
      <div className={classes.progressBar}>
        <LinearProgress
          className={classes.progressLine}
          classes={{
            root: classes.progressLine,
            barColorPrimary: classes.primaryBar,
          }}
          variant="determinate"
          value={progress}
        />
      </div>
    </>
  );
};

export default ProcessInProgress;
